import { config } from "./config";
import * as Sentry from "@sentry/react";

export function init() {
  if (config.sentry.enabled) {
    Sentry.init({
      dsn: config.sentry.dsn,
      environment: config.target,
      sampleRate: 0.1,
      release: config.appVersion,
      allowUrls: [/\/[a-z]{2}\/[a-z]{2}\/stores\/events\/static\/js\//],
    });
  }
}
